import Immutable from 'immutable';
import ActionTypes from '../ActionTypes';
import createReducer from '../../util/createReducer';

const initialState = Immutable.fromJS({
  inquiry: Immutable.fromJS({
    tripDetails: {
      id: '',
      inbox: '',
      category: '',
      destination: '',
      travelStartDate: '',
      travelEndDate: '',
      specificDates: true,
      timeframe: '',
      selectedUser: '',
      notes: '',
      vipNotes: '',
      editing: true,
    },
    travelers: [],
    itinerary: [],
  }),
  meta: Immutable.fromJS({
    addingTraveler: true,
    addingSegment: false,
    showOverview: true,
  }),
});

export default createReducer(initialState, {
  [ActionTypes.Inquiry.toggleNewTraveler](state, { value }) {
    return state.setIn(['meta', 'addingTraveler'], value);
  },
  [ActionTypes.Inquiry.addTraveler](state, { traveler }) {
    const travelers = state.getIn(['inquiry', 'travelers']);
    return state.setIn(
      ['inquiry', 'travelers'], travelers.push(traveler)
    ).setIn(['meta', 'addingTraveler'], false);
  },
  [ActionTypes.Inquiry.moveTraveler](state, { start, end }) {
    const travelers = state.getIn(['inquiry', 'travelers']);
    const target = travelers.get(start);

    return state.setIn(
      ['inquiry', 'travelers'], travelers.delete(start).insert(end, target));
  },
  [ActionTypes.Inquiry.removeTraveler](state, { index }) {
    return state.deleteIn(['inquiry', 'travelers', index]);
  },
  [ActionTypes.Inquiry.removeSegment](state, { index }) {
    return state.deleteIn(['inquiry', 'itinerary', index]);
  },
  [ActionTypes.Inquiry.updateField](state, { field, value }) {
    return state.setIn(field, value);
  },
  [ActionTypes.Inquiry.addSegment](state, { segment }) {
    const itinerary = state.getIn(['inquiry', 'itinerary']);
    return state.setIn(['inquiry', 'itinerary'], itinerary.push(segment));
  },
  [ActionTypes.Inquiry.resetInquiryForm]() {
    return initialState;
  },
});



// WEBPACK FOOTER //
// /src/store/reducers/Inquiry.js